import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_paywall_with_social_proof~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_paywall_with_social_proof'
					),
			},
		},
	},
]

export default config
